import React, { useState } from 'react';
import axios from 'axios';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

function ChatBot() {
    const [message, setMessage] = useState('');
    const [chat, setChat] = useState([]);
    const { executeRecaptcha } = useGoogleReCaptcha();

    const sendMessage = async () => {
        if (!message.trim()) return;

        if (!executeRecaptcha) {
            alert('reCAPTCHA não está carregado.');
            return;
        }

        const recaptchaToken = await executeRecaptcha('submit');
        if (!recaptchaToken) {
            alert('Falha no reCAPTCHA. Tente novamente.');
            return;
        }

        const userMessage = { role: 'user', content: message };
        setChat([...chat, userMessage]);
        setMessage('');

        try {
            const response = await axios.post(
                process.env.REACT_APP_AZURE_FUNCTION_URL,
                { 
                    message: message,
                    threadId:"thread_8e5xdDvDsrziKGwupu9gsOQz" 
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-functions-key": process.env.REACT_APP_AZURE_FUNCTION_KEY
                    },
                    withCredentials: false
                }
            );
            const botMessage = { role: 'bot', content: response.data.response };
            setChat([...chat, userMessage, botMessage]);
        } catch (error) {
            console.error('Erro ao enviar mensagem:', error);
            setChat([...chat, { role: 'bot', content: 'Desculpe, o concierge está dormindo agora, por favor tente mais tarde.' }]);
        }
    };

    return (
        <div className="flex justify-center min-h-screen bg-gray-100">

            <div className="w-full p-4 shadow-lg rounded-xl bg-white">
                <div className="h-96 overflow-y-auto border rounded-lg p-4 bg-gray-100">
                    {chat.map((msg, index) => (
                        <div key={index} className={`mb-2 ${msg.role === 'user' ? 'text-right' : 'text-left'}`}>
                            <span className={`inline-block px-3 py-2 rounded-lg ${msg.role === 'user' ? 'bg-blue-500 text-white' : 'bg-gray-300 text-black'}`}>
                                {msg.content}
                            </span>
                        </div>
                    ))}
                </div>

                <div className="mt-4 flex max-w-full">
                    <input
                        type="text"
                        className="flex-1 p-4 text-lg border border-gray-300 rounded-l-lg outline-none cursor-text max-w-[90%]"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && sendMessage()}  
                        placeholder="Digite sua pergunta aqui"
                        tabIndex={0}
                    />
                    <button
                        className="bg-green-700 text-white px-4 py-2 rounded-r-lg flex items-center gap-2"
                        onClick={sendMessage}
                    >
                        <FontAwesomeIcon icon={faPaperPlane} />
                    </button>                
                </div>
            </div>

        </div>
    );
}

export default ChatBot;
